import {
  Col,
  Divider,
  Row,
  Spin,
  Tabs
} from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import coin from "./../../../images/coin.png";
import employeeImg from "./../../../images/employee.jpg";
import log from "./../../../images/log.png";

import { getEmployees } from "../../../lib/getEmployees";
import { getOwnInvoicesByStatus } from "../../../lib/getOwnInvoicesByStatus";
import ModalPreviewPDF from "../../pages/company/ModalPreviewPDF";
const Home = () => {
  const [pendingInvoices, setPendingInvoices] = useState([]);
  const [acceptedInvoices, setAcceptedInvoices] = useState([]);
  const [canceledInvoices, setCanceledInvoices] = useState([]);
  const [selectedInvoice, setSelectedInvoice] = useState();
  const [showPreviewPDF, setShowPreviewPDF] = useState(false);
  const [totalEmpleados, setTotalEmpleados] = useState(0)
  const [loading, setLoading] = useState(true);
  const storage = JSON.parse(window.localStorage.getItem("userDetails"));
  const calcularTotal = (data) => {
    const total = Object.values(data).reduce(
      (accumulator, employee) =>
        accumulator +
        employee.reduce(
          (empAccumulator, emp) => empAccumulator + emp.calculatedSalary,
          0
        ),
      0
    );

    return Number(total).toLocaleString("de-DE", { maximumFractionDigits: 2 });
  };

  useEffect(() => {
    if (storage?.role === "admin_empleados") {
      setLoading(false);
      return;
    }

    getOwnInvoicesByStatus(storage.companyProfile?._id).then((res) => {
      setLoading(false);
      setPendingInvoices(
        res.data[0].invoices.filter((x) => x.status === "PENDING")
      );
      setAcceptedInvoices(
        res.data[0].invoices.filter((x) => x.status === "ACCEPTED")
      );
      setCanceledInvoices(
        res.data[0].invoices.filter((x) => x.status === "CANCELED")
      );
    });
    getEmployees().then((res) => {
      console.log("DATA1111", res.data);
      setTotalEmpleados(res.data?.length)
    });
  }, [storage?.role, storage?.companyProfile?._id]);

  const Pendientes = () => {
    return (
      <>
        {pendingInvoices.length > 0 &&
          pendingInvoices.map((invoice, index) => {
            if (invoice.status === "PENDING") {
              return (
                <>
                  <Row
                    style={{
                      marginTop: "10px",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Col xs={2} sm={4} md={6} lg={8} xl={10}>
                      <p style={{ fontWeight: "bold" }} key={index}>
                        Factura Nº: {invoice.invoiceNumber}
                      </p>
                      <p>
                        <strong>Período : </strong>
                        {moment(invoice.period[0]).format("DD/MM/YYYY")} -{" "}
                        {moment(invoice.period[1]).format("DD/MM/YYYY")}
                      </p>
                    </Col>
                    <Col xs={20} sm={16} md={12} lg={8} xl={8}></Col>
                  </Row>
                  <Divider style={{ backgroundColor: "#e6e6e6" }} />
                </>
              );
            }
          })}
      </>
    );
  };

  const Aceptadas = () => {
    return (
      <>
        {acceptedInvoices.length > 0 &&
          acceptedInvoices.map((invoice, index) => {
            if (invoice.status === "ACCEPTED") {
              return (
                <>
                  <Row
                    style={{
                      marginTop: "10px",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Col xs={2} sm={4} md={6} lg={8} xl={10}>
                      <p style={{ fontWeight: "bold" }} key={index}>
                        Factura Nº: {invoice.invoiceNumber}
                      </p>
                      <p>
                        <strong>Período : </strong>
                        {moment(invoice.period[0]).format("DD/MM/YYYY")} -{" "}
                        {moment(invoice.period[1]).format("DD/MM/YYYY")}
                      </p>
                      <p>
                        <strong>
                          Importe total : $ {calcularTotal(invoice.detail)}
                        </strong>
                      </p>
                    </Col>
                    <Col xs={20} sm={16} md={12} lg={8} xl={8}></Col>

                    <Link
                      to={"#"}
                      onClick={() => {
                        setSelectedInvoice(invoice);
                        setShowPreviewPDF(true);
                      }}
                      className="btn btn-warning shadow btn-xs sharp me-3"
                    >
                      <i className="fas fa-eye"></i>
                    </Link>
                  </Row>
                  <Divider style={{ backgroundColor: "#e6e6e6" }} />
                </>
              );
            }
          })}
      </>
    );
  };

  const Canceladas = () => {
    return (
      <>
        {canceledInvoices.length > 0 &&
          canceledInvoices.map((invoice, index) => {
            if (invoice.status === "CANCELED") {
              return (
                <>
                  <Row
                    style={{
                      marginTop: "10px",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Col xs={2} sm={4} md={6} lg={8} xl={10}>
                      <p style={{ fontWeight: "bold" }} key={index}>
                        Factura Nº: {invoice.invoiceNumber}
                      </p>
                      <p>
                        <strong>Período : </strong>
                        {moment(invoice.period[0]).format("DD/MM/YYYY")} -{" "}
                        {moment(invoice.period[1]).format("DD/MM/YYYY")}
                      </p>
                    </Col>
                    <Col xs={20} sm={16} md={12} lg={8} xl={8}>
                      <strong>Motivo:</strong> {invoice.motive}
                    </Col>
                  </Row>
                  <Divider style={{ backgroundColor: "#e6e6e6" }} />
                </>
              );
            }
          })}
      </>
    );
  };

  const items = [
    {
      key: "1",
      label: `PENDIENTES (${pendingInvoices.length})`,
      children: <Pendientes />,
    },
    {
      key: "2",
      label: `ACEPTADAS (${acceptedInvoices.length})`,
      children: <Aceptadas />,
    },
    {
      key: "3",
      label: `CANCELADAS (${canceledInvoices.length})`,
      children: <Canceladas />,
    },
  ];

  return (
    <>
      {/* Dashboard for admin_empleados: only "Acceder a Empleados" */}
      {storage && storage.role === "admin_empleados" && (
        <div className="row">
          <div className="col-xl-12">
            <div className="card bubles">
              <div className="card-body">
                <div className="buy-coin bubles-down">
                  <div>
                    <h2 className="cargaEMpleados" style={{width:"100%"}}>Empleados</h2>
                    <p style={{ width: "100%" }}>
                      Accedé al listado de empleados para buscar y exportar.
                    </p>
                    <Link to={"/all-employees"} className="btn btn-primary">
                      Ir a Empleados
                    </Link>
                  </div>
                  <div className="coin-img">
                    <img src={employeeImg} className="img-fluid" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Dashboard for admin and superadmin (rest of content) */}
      {storage && storage.role !== "admin_empleados" && (
        <>
      <div className="row">
        <div className="col-xl-12">
          <div className="row">
            <div className="col-xl-12">
              <div className="card bubles">
                <div id="cardCargaEmpleado" className="card-body">
                  {storage && storage.role === "admin" ? (
                    <div className="buy-coin  bubles-down">
                      <div>
                        <h2 className="cargaEMpleados" style={{width:"100%"}}>Empleados</h2>
                        <p style={{width:"100%"}}>
                          Aquí podras incorporar un nuevo empleado y gestionar
                          los registrados.
                        </p>
                        <Link
                          to={"/employee-management"}
                          className="btn btn-primary"
                        >
                          + Ir a Empleados
                        </Link>
                      </div>
                      <div className="coin-img">
                        <img src={coin} className="img-fluid" alt="" />
                      </div>
                    </div>
                  ) : (
                    <>
                      <div className="buy-coin  bubles-down">
                        <div>
                          <h3 className="cargaEMpleados">Panel de facturación </h3>
                          <p style={{width:"100%"}}>
                            Aquí podras gestionar las facturas solicitadas por
                            las empresas.
                          </p>
                          <Link
                            to={"/invoice-management"}
                            className="btn btn-primary"
                          >
                            Ir a panel de facturación
                          </Link>
                        </div>
                        <div className="coin-img">
                          <img src={log} className="img-fluid" alt="" />
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
            {/* <div className="col-xl-12">
              <CardsHome />
            </div> */}
          </div>
        </div>
      </div>
      {/* SEPARATOR */}
      <div className="row">
        <div className="col-xl-12">
          <div className="row">
            <div className="col-xl-12">
              <div className="card bubles">
                <div id="cardCargaEmpleado" className="card-body">
                  {storage && storage.role === "admin" ? (
                    <>
                      <h3 className="">Panel de facturación</h3>
                      <div style={{ maxHeight: "400px", overflow: "auto" }}>
                        {loading ? (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <Spin />
                          </div>
                        ) : (
                          <Tabs defaultActiveKey="1" items={items} />
                        )}
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="buy-coin  bubles-down mt-5">
                        <div>
                          <h3 className="cargaEMpleados">Gestión de empresas </h3>
                          <p style={{width:"100%"}}>
                            Aquí podras gestionar nuevos registros y las
                            empresas ya existentes.
                          </p>
                          <Link
                            to={"/business-control-panel"}
                            className="btn btn-warning"
                          >
                            Ir a gestión de empresas
                          </Link>
                        </div>
                        <div className="coin-img">
                          <img src={coin} className="img-fluid" alt="" />
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
            {/* <div className="col-xl-12">
              <CardsHome />
            </div> */}
          </div>
        </div>
      </div>


     
                  { storage && storage.role === "superadmin" && (
                     <>
                      <div className="row">
        <div className="col-xl-12">
          <div className="row">
            <div className="col-xl-12">
              <div className="card bubles">
                <div id="cardCargaEmpleado" className="card-body"></div>
                     <div className="buy-coin  bubles-down mt-5">
                       <div>
                         <h3 className="cargaEMpleados">Gestión de Empledos  ({ totalEmpleados})</h3>
                         <p style={{width:"100%"}}>
                           Aqui podras buscar y ordernar  todos empleados 
                         </p>
                         <Link
                           to={"/all-employees"}
                           className="btn btn-info"
                         >
                           Ir a gestión de empleados
                         </Link>
                       </div>
                       <div className="coin-img">
                         <img src={employeeImg} className="img-fluid" alt="" />
                       </div>
                     </div>
                     </div>
                     </div>
                     </div>
                     </div>
                     </div>
           
                   </>
                      )
                  }
     
            {/* <div className="col-xl-12">
              <CardsHome />
            </div> */}
        </>
      )}

      {showPreviewPDF && (
        <ModalPreviewPDF
          showOpen={showPreviewPDF}
          setShowOpen={setShowPreviewPDF}
          selectedInvoice={selectedInvoice}
        />
      )}
    </>
  );
};
export default Home;
